import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconAnthropic: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"anthropic"} maskId="square-filled-radius-0-stroke-1-IconAnthropic"><path d="M17.0977 4H13.5611L19.8941 20H23.3484L17.0977 4ZM6.89916 4L0.648438 20H4.18503L5.58322 16.6359H12.1629L13.4789 19.9179H17.0155L10.6003 4H6.98141H6.89916ZM6.57018 13.6821L8.70858 8.02051L10.9292 13.6821H6.65242H6.57018Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconAnthropic;
